import { KnownCookie } from 'common-types';
import Cookies from 'js-cookie';
import { useRouter } from 'next/router';
import React, { useCallback } from 'react';
import { useTimeoutFn } from 'react-use';
import { useConfigurationProperty } from '~/contexts/ConfigurationContext';
import { useModals } from '~/contexts/ModalsContext';
import { useSession } from '~/contexts/SessionContext';
import isGearExpertsOnlineScheduled from '~/utils/isGearExpertsOnlineScheduled';
import {
  FT_GEAR_EXPERTS_POPUP,
  FT_GEAR_EXPERTS_USE_SCHEDULE,
  FT_JOIN_MODAL_POPUP,
} from '../../constants/featureToggles';

interface Props {}

const AutomaticPopupModal: React.FC<Props> = () => {
  const modals = useModals();
  const session = useSession();
  const router = useRouter();
  const gearExpertsEnabled = useConfigurationProperty('gear_experts');

  useTimeoutFn(
    useCallback(() => {
      if (!FT_JOIN_MODAL_POPUP) {
        return null;
      }

      if (
        session.loggedIn ||
        modals.modals.find(m => m.type === 'loginRegister') ||
        Cookies.get('seen_acquisition_test') === '1' ||
        router.route === '/gear_experts' ||
        router.route === '/register' ||
        router.route === '/login'
      ) {
        return;
      }

      modals.openModal('loginRegister', {
        defaultView: 'register',
        src: 'automatic',
        modalWidth: 600,
      });
      Cookies.set('seen_acquisition_test' as KnownCookie, '1', {
        expires: 14,
      });
    }, []),
    30000,
  );

  useTimeoutFn(
    useCallback(() => {
      const pathname = router.asPath.split('?')[0];

      let shouldSeePopup = false;

      if (
        (pathname === '/' || /\/(hockey|golf|baseball)/i.test(router.asPath)) &&
        modals.modals.length === 0
      ) {
        if (
          Cookies.get('typeform_submitted') !== '1' &&
          Cookies.get('seen_gear_experts_popup') !== '1'
        ) {
          if (FT_GEAR_EXPERTS_POPUP) {
            shouldSeePopup = true;
            if (FT_GEAR_EXPERTS_USE_SCHEDULE) {
              shouldSeePopup = isGearExpertsOnlineScheduled();
            }
          }
        }
      }

      // The Rails config ultimately has the final say.
      // If the config is disabled, totally disable it.
      if (!gearExpertsEnabled) {
        shouldSeePopup = false;
      }

      if (shouldSeePopup) {
        modals.openModal('gearExpertsPopup', {
          modalWidth: 600,
        });
        Cookies.set('seen_gear_experts_popup', '1', {
          expires: 30,
        });

        // Don't allow other popups to open
        return;
      }
    }, []),
    30000,
  );

  return null;

  /*
  Here's some cool code to a sticky bar at the bottom with the same error page texture.
  return (
    <div
      className="sticky bottom-0 flex w-full p-4 text-white space-x-4 bg-primary-500"
      css={`
        background-image: url(${require('~/public/static/green-pattern.png')});
        background-size: 300px;
        z-index: 100;
      `}
    >
      <div>Sign up!</div>
    </div>
  );*/
};

export default AutomaticPopupModal;
